// Hook do pobierania słownika klientów – GET /sales-crm/clients/dictionary

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface ISalesCrmClientsDictionaryItem {
  text: string;
  value: number;
}

export interface IGetSalesCrmClientsDictionaryResponse {
  page?: number;
  total_count?: number;
  total_pages?: number;
  items: ISalesCrmClientsDictionaryItem[];
}

const getSalesCrmClientsDictionary =
  (): Promise<IGetSalesCrmClientsDictionaryResponse> =>
    axios.get('/sales-crm/clients/dictionary');

export const useGetSalesCrmClientsDictionary = (
  options?: UseQueryOptions<IGetSalesCrmClientsDictionaryResponse, IError>
) =>
  useQuery<IGetSalesCrmClientsDictionaryResponse, IError>(
    ['sales-crm', 'clients', 'dictionary'],
    () => getSalesCrmClientsDictionary(),
    options
  );
